import { IVoteBallotView, IVoteVoterView } from '../../types/voteTypes';

// Builds the standard auth query string required by VoteAuthFilter on all vote API endpoints.
// Include in any URL that targets a VoteController action.
export function buildAuthQueryString(voter: IVoteVoterView, ballot: IVoteBallotView, previewId: String | null): string {
    const idQueryParam = voter.uniqueId ? `&id=${voter.uniqueId}` : "";
    const previewIdQueryParam = previewId ? `&preview=${previewId}` : "";
    const personalIdQueryParam = voter.personalId ? `&pId=${voter.personalId}` : "";
    return `b=${ballot.id}${idQueryParam}&key=${voter.guid}${previewIdQueryParam}${personalIdQueryParam}`;
}
